<template>
  <div class="contain2">
    <div class="contain-box3">
        <div class="filter-container">
            <div class="filter-container-left">
                <div class="filter-title">电竞技能课程题库</div>
            </div>
        </div>
    </div> 
    <div class="list">
        <div class="box" v-for="(item,index) in 3" :key="index" :style="{backgroundImage: index==0?'url(' + coverImgUrl3 + ')':index==1?'url(' + coverImgUrl + ')':'url(' + coverImgUrl2 + ')', backgroundSize:'contain'}" @click="goSubject(index)">
            <div class="title">{{index==0?'顺序答题':index==1?'随机答题':'答题记录'}}</div>
            <div class="total" v-if="index==0">共100题</div>
        </div>
    </div>
  </div>
</template>

<script>

import request from '@/utils/request'

export default {
  data() {
    return {
        coverImgUrl:require('../../../../assets/image/subject_1.png'),
        coverImgUrl2:require('../../../../assets/image/subject_2.png'),
        coverImgUrl3:require('../../../../assets/image/subject_3.png')
    }
  },
  created() {

  },
  methods: {
    goSubject(index){
        if(index==0){
            this.$router.push({
                path:'/mine/my_study/question_bank/subject',
                query:{
                    student_question_bank_type_id:this.$route.query.student_question_bank_type_id
                }
            })
        }else if(index==1){
           this.$router.push({
                path:'/mine/my_study/question_bank/subject',
                query:{
                    student_question_bank_type_id:this.$route.query.student_question_bank_type_id,
                    is_random:1
                }
            })
        }else{
            this.$router.push('/mine/my_study/question_bank/record')
        }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.contain2{
    background: #FFFFFF;
    border-radius: 8px;
    height: calc(100vh - 120px); 
.contain-box3{
    background: #FFFFFF;
    border-radius: 8px;
    padding: 11px 0 30px 0;
    .filter-container{
        // height: 90px;
        padding: 0 20px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        // margin-bottom: 30px;
        .filter-container-left{
            .filter-title{
                padding: 30px;
                font-size: 26px;
                font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
                font-weight: bold;
                color: #506176;
                border-bottom: 1px solid #F9FAFD;
            }
        }
    }
}
.list{
    margin-top: 30px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
}
.box{
    width: 22%;
    height: 400px;
    // background-image: url('../../../../assets/logo.png');
    background-repeat: no-repeat;
    background-size: 100%;
    // border: 1px springgreen solid;
    border-radius: 9px;
    padding: 35px 30px;
    .title{
        font-size: 32px;
        font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
        font-weight: bold;
        color: #FFFFFF;
    }
    .total{
        margin-top: 10px;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
    }
}
}
</style>
